export const MessageType = Object.freeze({
  INIT_DATA: 'init_data',
  IFRAME_READY: 'iframe_ready',
  TEST_STARTED: 'test_started',
  TEST_FINISHED: 'test_finished',
  TEST_RECEIVED_SESSION_ID: 'test_received_session_id'
});
